import * as z from 'zod';
import { Data as Data$1, Close as Close$1 } from './contract/contract-surety-bond.types.mjs';
import * as contractSuretyBond_types from './contract/contract-surety-bond.types.mjs';
export { contractSuretyBond_types as Contract };
export { Obligee } from './obligee.types.mjs';

var Data;
(function (Data) {
    Data.schema = z.discriminatedUnion("suretyType", [Data$1.schema]);
})(Data || (Data = {}));
var Close;
(function (Close) {
    (function (Payload) {
        Payload.schema = z.discriminatedUnion("suretyType", [Close$1.Payload.schema]);
    })(Close.Payload || (Close.Payload = {}));
})(Close || (Close = {}));

export { Close, Data };
